var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-na",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0 0h512v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3662a2",
    d: "m-108.2.2.8 368.6L466.6 0l-574.8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38a100",
    d: "m630.7 511.5-1.4-383.2-579 383.5 580.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c70000",
    d: "m-107.9 396.6.5 115.4 125.3-.2 611.7-410.1L629 1.4 505.2.2l-613 396.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    d: "m154 183.4-23.1-14-13.4 23.6-13-23.8L81 183l.6-27.1-27 .2 14-23.2L45 119.5l23.8-13L55 83l27 .6-.1-27.1 23.2 14 13.4-23.6 13 23.7L155.2 57l-.6 27 27-.1-14 23.2 23.6 13.3-23.8 13.1 13.7 23.4-27-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3662a2",
    d: "M167.8 120c0 27.2-22.3 49.3-49.8 49.3s-49.7-22.1-49.7-49.4 22.3-49.3 49.8-49.3 49.7 22 49.7 49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    d: "M157 120a39 39 0 1 1-77.9 0 39 39 0 0 1 77.9 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNa);
export default __webpack_public_path__ + "static/media/na.3c91593c33560a76d95b941fb7d86364.svg";
export { ForwardRef as ReactComponent };